import download from "downloadjs";
import { downloadPatientAttachmentAPI } from "../api/api";
import ErrorMessage from "../component/customComponent/customMessages/ErrorMessage";
import SuccessMessage from "../component/customComponent/customMessages/SuccessMessage";
/**
 * Download a patient attachment - shared utility used by Uploader.js and other components
 * @param {Object} attachment - Attachment object
 * @param {string} attachment.id - Attachment ID
 * @param {string} attachment.attachmentUniqueId - Unique attachment ID
 * @param {string} attachment.filename - Filename for download
 * @param {Function} setLoading - Loading state setter function
 */
export const downloadAttachment = (attachment, setLoading) => {
  setLoading(true);
  downloadPatientAttachmentAPI(attachment.id, attachment.attachmentUniqueId)
    .then((blob) => {
      const content = "application/pdf";
      download(blob, attachment.filename, content);
      SuccessMessage("Download successful.");
    })
    .catch(() => {
      ErrorMessage("Download failed.");
    })
    .finally(() => {
      setLoading(false);
    });
};
